import { render } from "./_PanelResidentStatementOfTaxPayee.vue?vue&type=template&id=2e3bfc69"
import script from "./_PanelResidentStatementOfTaxPayee.vue?vue&type=script&lang=js"
export * from "./_PanelResidentStatementOfTaxPayee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__